module.exports = __webpack_public_path__ + "static/media/node.61d3eab0.svg";